const DetailItem = ({ icon, label, value, borderRight = false }) => {
  if (!value || value === "Not Specified") return null;

  return (
    <div
      className={`flex items-center gap-2 ${
        borderRight ? "border-r border-gray-200 pr-3" : ""
      }`}
    >
      <div className="flex-shrink-0 mt-0.5">{icon}</div>
      <div className="flex-1 min-w-0">
        <p className="text-gray-500 text-sm">{label}</p>
        <p className="text-gray-900 text-sm font-medium break-words">{value}</p>
      </div>
    </div>
  );
};
export default DetailItem